import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommerceService } from 'app/services/commerce.service';

@Component({
  selector: 'edit-availed-product-status',
  standalone: false,
  templateUrl: './edit-availed-product-status.component.html',
  styleUrl: './edit-availed-product-status.component.scss'
})
export class EditAvailedProductStatusComponent implements OnInit {

  @Input() productStatus: number = 0;
  @Output() isStatusInvalid = new EventEmitter<boolean>();
  @Output() selectedStatusOutput = new EventEmitter<any>();

  constructor(
    private commerceService: CommerceService
  ){}

  public status: any[] = [];

  public selectedStatus: any;

  ngOnInit(): void {
    this.status = [
      {name: 'Pause', disabled: this.productStatus === 4, value: 'Paused'},
      {name: 'Resume', disabled: this.productStatus === 3, value: 'Resume'},
      {name: 'Cancel', disabled: true, value: 'Cancelled'},
      {name: 'Suspend', disabled: true, value: 'Suspended'}
    ];
  }

  statusChanged(){
    this.commerceService.resetAvailedProductsEdit();
    this.commerceService.availedProductStatus = this.selectedStatus;
    this.selectedStatusOutput.emit(this.selectedStatus);
    this.isStatusInvalid.emit(!this.selectedStatus);
  }
}
